
import { useTranslation } from 'react-i18next';

export default function StrengthsSection() {
  const { t } = useTranslation();

  const strengths = [
    {
      icon: 'ri-shield-check-line',
      title: t('management.strengths.items.0.title'),
      description: t('management.strengths.items.0.description')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('management.strengths.items.1.title'),
      description: t('management.strengths.items.1.description')
    },
    {
      icon: 'ri-line-chart-line',
      title: t('management.strengths.items.2.title'),
      description: t('management.strengths.items.2.description')
    }
  ];

  return (
    <section className="relative py-20 bg-gradient-to-b from-amber-50 via-stone-50 to-amber-50 font-serif">
      {/* 上部装飾ライン - 市松模様 */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-60"></div>
      <div className="absolute top-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-50"></div>

      {/* 下部装飾ライン - 市松模様 */}
      <div className="absolute bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-50"></div>
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-60"></div>

      <div className="max-w-7xl mx-auto px-6">
        {/* セクションタイトル */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-stone-800 mb-4">
            ◆ {t('management.strengths.title')} ◆
          </h2>
          
          {/* 金色装飾ライン */}
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-[#c9a84c]"></div>
            <span className="text-[#8b2500] text-xl">◇</span>
            <div className="h-px w-32 bg-[#c9a84c]"></div>
            <span className="text-[#8b2500] text-xl">◇</span>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-[#c9a84c]"></div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {strengths.map((strength, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-b from-stone-50 to-amber-50/50 p-8 rounded-lg border-2 border-[#8b2500]/20 hover:border-[#8b2500]/40 transition-all duration-300 hover:shadow-xl"
            >
              {/* 四隅装飾 */}
              <div className="absolute top-2 left-2 w-4 h-4 border-t-2 border-l-2 border-[#8b2500] opacity-60"></div>
              <div className="absolute top-2 right-2 w-4 h-4 border-t-2 border-r-2 border-[#8b2500] opacity-60"></div>
              <div className="absolute bottom-2 left-2 w-4 h-4 border-b-2 border-l-2 border-[#8b2500] opacity-60"></div>
              <div className="absolute bottom-2 right-2 w-4 h-4 border-b-2 border-r-2 border-[#8b2500] opacity-60"></div>

              {/* アイコン - 漆塗り風背景 */}
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-b from-[#8b2500] to-[#6b1d00] rounded-full mb-6 mx-auto group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${strength.icon} text-3xl text-[#c9a84c]`}></i>
              </div>

              <h3 className="text-xl font-bold text-stone-800 mb-4 text-center">
                ◇ {strength.title}
              </h3>
              <p className="text-stone-600 leading-relaxed text-center">
                {strength.description}
              </p>
            </div>
          ))}
        </div>

        {/* 画像セクション */}
        <div className="relative max-w-4xl mx-auto">
          {/* 朱色・金色の二重枠線 */}
          <div className="absolute -inset-3 border-4 border-[#8b2500] rounded-lg"></div>
          <div className="absolute -inset-1 border-2 border-[#c9a84c] rounded-lg"></div>
          
          {/* 四隅装飾 */}
          <div className="absolute -top-4 -left-4 w-10 h-10 border-t-4 border-l-4 border-[#8b2500]"></div>
          <div className="absolute -top-4 -right-4 w-10 h-10 border-t-4 border-r-4 border-[#8b2500]"></div>
          <div className="absolute -bottom-4 -left-4 w-10 h-10 border-b-4 border-l-4 border-[#8b2500]"></div>
          <div className="absolute -bottom-4 -right-4 w-10 h-10 border-b-4 border-r-4 border-[#8b2500]"></div>

          <div className="relative rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/065f3143539bab043b7c7faad0f84108.jpg"
              alt={t('management.strengths.title')}
              className="w-full h-[400px] object-cover sepia-[0.3] contrast-110"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
